import React from 'react';
import * as styles from './Footer.module.scss';
import {GatsbyImage} from "gatsby-plugin-image";

type Props = {
    authors: Queries.AuthorsJson[]
}

export const Footer = ({authors}: Props) => {


    return (
        <>
            {authors.map((item, index) => {
                return <>
                    {item?.data?.name?.iv &&
                        <div className={styles.container}>
                            {item?.authorImage?.childImageSharp?.gatsbyImageData &&
                                <GatsbyImage className={styles.avatar} alt={item?.data?.name?.iv}
                                             image={item?.authorImage?.childImageSharp?.gatsbyImageData}/>}
                            <div className={styles.content}>
                                <div className={styles.info}>
                                    <span className={styles.name}>{item?.data?.name?.iv}</span>
                                    {Boolean(item?.data?.name && item.data?.description) &&
                                        <span className={styles.splitter}>&nbsp;|&nbsp;</span>}
                                    <span className={styles.position}>{item?.data?.description?.iv}</span>
                                </div>
                                <div className={styles.social}>
                                    { /* item?.data.linkedin && <TwitterIcon className={styles.icon} /> */}
                                </div>
                            </div>
                        </div>
                    }
                </>
            })}
        </>

    )
}
